import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import Modal from '../../../shared/components/ui/Modal';
import FormInput from '../../../shared/components/ui/FormInput';
import Button from '../../../shared/components/ui/Button';
import { requestManagementTaskOwnerTransfer } from '../../services/api/implementation/impl';
import toast from 'react-hot-toast';

// Ownership moves as soon as this is saved — the new owner does not accept it.
const TransferOwnerModal = ({ task, usersOptions, onClose, onSuccess }) => {
  const { register, handleSubmit } = useForm({
    defaultValues: { toUserId: '' }
  });
  const [submitting, setSubmitting] = useState(false);

  const options = (usersOptions || []).filter(
    (u) => String(u.value) !== String(task?.owner_id)
  );

  const mutation = useMutation({
    mutationFn: (toUserId) => requestManagementTaskOwnerTransfer(task.id, toUserId),
    onSuccess: () => {
      toast.success('Ownership transferred');
      onSuccess?.();
      onClose();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to transfer ownership');
    }
  });

  const onSubmit = (data) => {
    const toUserId = Number(data.toUserId);
    if (!toUserId) {
      toast.error('Select a new owner');
      return;
    }
    setSubmitting(true);
    mutation.mutate(toUserId, { onSettled: () => setSubmitting(false) });
  };

  return (
    <Modal name="Transfer owner" width={40} onClose={onClose} hideClose={false}>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <p className="text-sm text-gray-600">
          Current owner: <span className="font-medium">{task?.owner?.name || '—'}</span>.
          The new owner takes over straight away.
        </p>
        <FormInput
          label="New owner"
          register={register}
          register_key="toUserId"
          type="dropdown"
          options={options}
          isRequired={true}
          width={100}
        />
        <div className="flex justify-end gap-3 pt-2">
          <Button
            type="button"
            onClick={onClose}
            className="bg-gray-200 text-gray-800 px-6 py-2 rounded hover:bg-gray-300"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            disabled={submitting}
            className="bg-[#346C75] text-white px-8 py-2 rounded hover:bg-[#2a565e]"
          >
            {submitting ? 'Transferring...' : 'Transfer owner'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default TransferOwnerModal;
